import { PromoCodeGet } from '../../domain/PromoCodesSlice/PromoCodeGet';
import { PromoCodeValidate } from '../../domain/PromoCodesSlice/PromoCodeValidate';
import ApiWrapperAuthenticated from '../Common/ApiWrapperAuthenticated';

export class PromoCodeClientMeRepository 
    extends ApiWrapperAuthenticated {
    constructor() {
        super('clients/me/promos/');
    }

    async fetchAllVisible(): Promise<PromoCodeGet[] | null> {
        return await this.getListAllAuthenticatedCustom({ url: 'visible' });
    }

    async validatePromo(promo: PromoCodeValidate): Promise<PromoCodeGet | null> {
        return await this.postAuthenticatedCustom({ url: 'validate', data: promo });
    }
}
